module.exports = __webpack_public_path__ + "static/media/MC.b03dc413.png";